/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo } from 'react';

import { InfoCircleIcon, CrossCircleIcon } from '@vlabs/icons';
import { Table } from '@vlabs/uikit';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import st from './IsoErrorsTab.module.sass';
import type { IsoErrorsTabProps } from '../types';
import { checksValueMapperByType } from '../utils';

export function IsoErrorsTab({ results }: IsoErrorsTabProps): React.JSX.Element {
  const { t } = useTranslation();

  const checksArray = [...(results?.detection?.iso?.checks ?? [])];
  const sortedChecks = checksArray?.sort((a, b) => a.result - b.result);
  const checks = sortedChecks.map(checksValueMapperByType);
  const errorChecks = checks.filter(({ result, object_value }) => !result && object_value !== null);
  const notEstimatedChecks = checks.filter(({ result, object_value }) => !result && object_value === null);

  const title = (
    <div className={st.IsoResultTitle}>
      <div className={st.IsoIcon}>
        <div className={st.LinearGradient}>
          <CrossCircleIcon className={st.CrossIcon} />
        </div>
      </div>
      <div className={st.Title}>
        <span className={st.ComplianceTitle}>{t('monokit:create face modal.iso.title.compliance')}</span>
        <span className={st.VerificationTitle}>{t('monokit:create face modal.iso.title.verification failed')}</span>
      </div>
    </div>
  );

  const iconCell = useCallback((({ value }) => {
    return (
      <div
        className={cn({
          [st.StateColor_error]: value === 0,
          // для отображения опущенной проверки (без значения) из notEstimatedChecks при кейсе с warp
          [st.StateColor_neutral]: value === 2,
        })}
      >
        <CrossCircleIcon />
      </div>
    );
  }), [errorChecks]);

  const columns = useMemo(() => ([
    { accessor: 'result', Cell: iconCell },
    { Header: t('monokit:create face modal.iso.title.check'), accessor: 'checkName' },
    { Header: t('monokit:create face modal.iso.title.result'), accessor: 'checkValue' },
    { Header: t('monokit:create face modal.iso.title.acceptable'), accessor: 'tableText' },
  ]), [t, iconCell]);

  if (!results?.detection) {
    return (
      <div className={st.NoResultsText}>
        <InfoCircleIcon className={st.InfoIcon} />
        <div>{t('monokit:create face modal.iso.no result tooltip')}</div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div>
        {title}
        {notEstimatedChecks.length > 0 && (
        <div className={st.Subtitle}>
            {t('monokit:create face modal.skipped checks.skipped checks counter', { count: notEstimatedChecks?.length })}
        </div>
        )}
      </div>
      <div className={st.Result}>
        <div className={st.Table}>
          <Table
            columns={columns}
            data={errorChecks}
            noBottomPanel
          />
        </div>
      </div>
    </React.Fragment>
  );
}
